import {useQueryParams, useQueryParamsCallback} from '@aboutyou/router';
import {SessionGender, useSessionGender} from './sessionGender';
import {convertGenderToTargetGroup} from './useSelectedTargetGroup';
import {useCallback} from 'react';

const getTargetGroupIdentifier = (
  queryParams: URLSearchParams,
  sessionGender: SessionGender | undefined,
) => {
  const paramGender = queryParams.get('gender');
  const gender = !paramGender ? sessionGender : paramGender;

  // type assertion ! used here because convertGenderToTargetGroup will default to FEMALE unless we pass {defaultToFemale: false}
  return convertGenderToTargetGroup({gender})!;
};

export const useTargetGroupIdentifier = () => {
  const queryParams = useQueryParams();
  const {gender: sessionGender} = useSessionGender();
  return getTargetGroupIdentifier(queryParams, sessionGender);
};

export const useTargetGroupIdentifierCallback = () => {
  const queryParamsCallback = useQueryParamsCallback();
  const {gender: sessionGender} = useSessionGender();
  return useCallback(() => {
    return getTargetGroupIdentifier(queryParamsCallback(), sessionGender);
  }, [sessionGender, queryParamsCallback]);
};
